<template>
  <v-app class="app-tabela mt-4">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome UBS"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColorTabelaMapa"
          :search="search"
          item-key="id"
          class="elevation-1"
          hide-default-footer
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <!-- <template v-slot:[`footer.page-text`]="items">
            <span class="paginacao"> {{ items.itemsLength }} UBS</span>
          </template> -->

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>

          <template v-slot:expanded-item="{ headers, item }"> </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaMapa',
  components: {},
  props: {
    dados: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_ubs',
        },
        {
          text: 'CNES',
          align: 'start',
          filterable: false,
          value: 'cnes',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: false,
          value: 'ine',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: false,
          value: 'tipo_equipe',
        },
        {
          text: 'PARÂMETRO',
          align: 'start',
          filterable: false,
          value: 'min_cad',
        },
        {
          text: 'CADASTROS E-SUS',
          align: 'start',
          filterable: false,
          value: 'denominador',
        },
        {
          text: 'MÁXIMO',
          align: 'start',
          filterable: false,
          value: 'max_cad',
        },
        {
          text: 'ATENÇÃO',
          align: 'start',
          filterable: false,
          value: 'recomendacao_cadastro',
        },
      ],
    }
  },
  watch: {
    dados: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.dados !== undefined) {
        return this.dados.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.dados.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    getRowColorTabelaMapa(item) {
      return 'table-row-color-' + Functions.getRowColorTabelaMapa(item)
    },
  },
}
</script>

<style scoped lang="scss"></style>
